import Apis from 'apis';
import React from 'react'
import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { refreshToken } from 'redux/reducers/user';
import { RootState } from 'redux/store';

import { isLogin } from 'routes/Auth/Auth';

function RefreshToken(props) {

    const refresh_interval = 1000 * 60
    const user = useSelector((state: RootState) => state.user)
    const dispatch = useDispatch()
    useEffect(() => {
        const intervalId = setInterval(() => {
            refreshTokenNow();
        }, refresh_interval);
        return () => {
            clearInterval(intervalId)
        }
    }, [])
    const refreshTokenNow = () => {
        const now = Date.now();
        const space = user.EXPIRES_ON - now

        if (isLogin() && !user.REMEMBER_ME && (space < refresh_interval)) {
            console.log('===>I am refreshing token')
            Apis.auth.putAuth(null, (response) => {
                dispatch(refreshToken(response))
            }, null)
        }
    };

    return <div></div>
}

export default (RefreshToken);